import { combineReducers } from 'redux';
import authUser from './auth/reducer';
import chatApp from './chat/reducer';
import menu from './menu/reducer';
import providers from './providers/reducer';
import settings from './settings/reducer';
import activeItem from './activeItem/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  providers,
  chatApp,
  activeItem,
});

export default reducers;